import type { RouteRecordRaw } from "vue-router";
import type { StandardFormRouteNames } from "@/views/electronicForm/electronicForm";

export function createDocumentChildRoutes(formRouteNames: StandardFormRouteNames): RouteRecordRaw[] {
  return [
    {
      path: "documents",
      name: formRouteNames.documents,
      meta: { title: "Documents" },
      component: () => import("@/views/electronicForm/documents/DocumentChildList.vue"),
    },
  ];
}
